import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsCalendarDay, BsDot, BsThreeDotsVertical } from "react-icons/bs";
import { HiOutlinePencil } from "react-icons/hi";
import { RiEyeLine, RiSearch2Line } from "react-icons/ri";
import Pagination from "react-paginate";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { AvailableCourseModal } from "../../../components/admin/AvailableCourseModal";
import { AdvertiseCourseModal } from "../../../components/admin/course/AdvertiseCourseModal";
import { AssignCourseModal } from "../../../components/admin/course/AssignCourseModal";
import { BulkCourseModal } from "../../../components/admin/course/BulkCourseModal";
import { DeleteCourseModal } from "../../../components/admin/course/DeleteCourseModal";
import Loading from "../../../components/common/Loading";
import engineering from "../../../img/bookpic.jpg";
import delete_vector from "../../../img/deleteVectorRed.svg";
import { ICourse, Trainer } from "../../../models/course.model";
import coursesService from "../../../services/courses.service";
import registrationService from "../../../services/registration.service";
import ExportExcel from "../../../utils/ExportExcel";
import Adminroutes from "../routes";

export const ExcelDataExport = [
  {
    "S/N": "1",
    "Course Title": " Example",
    "Course Type Code": "DISTRIBUTION",
    "Program Category Code": "NTCH",
    Cost: "20000",
    Discount: "1000",
    "Discount Type": "Rate",
    "Min Deposit": "0",
    "Number of Installment": "0",
    "Course Duration": "4",
    "Course Duration Unit": "Weeks",
    Status: "Draft/Published",
  },
];

const AdminCourses = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [courseAvailable, setAvailable] = useState(false);
  const [loading, setLoading] = useState(true);
  const [advertise, setAdvertise] = useState(false);
  const [assigncourse, setAssignCourse] = useState(false);
  const [deletecourse, setDeleteCourse] = useState(false);
  const [reload, setReload] = useState(false);
  const [isBulkCourse, setIsBulkCourse] = useState(false);
  const [courseId, setCourseId] = useState<string>("");
  const [id, setId] = useState<string | number>("");
  const [courses, setCourses] = useState<ICourse[]>([]);
  const [trainers, setTrainers] = useState<Trainer[]>([]);
  const [trainerIds, setTrainerIds] = useState<string[]>();
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [filteredCourses, setFilteredCourses] = useState<ICourse[]>([]);
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const pageRangeDisplayed = useBreakpointValue({
    base: 3,
    sm: 3,
    md: 5,
    lg: 5,
  });
  const showLabels = useBreakpointValue({
    base: false,
    sm: false,
    md: true,
    lg: true,
  });

  const navigate = useNavigate();
  const viewCourse = async (course_id: string) => {
    navigate(Adminroutes.ACourseLink(course_id));
  };

  useEffect(() => {
    registrationService
      .getAllCourses()
      .then((response) => {
        const courses: ICourse[] = response;
        coursesService
          .getAvailableCourses()
          .then((availableCourses) => {
            const availableCourseIds = availableCourses.map(
              (course) => course.course_id
            );
            const updatedCourses = courses.map((course) => ({
              ...course,
              is_available: availableCourseIds.includes(course.id),
            }));
            setCourses(
              updatedCourses.filter(
                (course) => course.status === 1 && course.is_program !== 1
              )
            );
            setFilteredCourses(
              updatedCourses.filter(
                (course) => course.status === 1 && course.is_program !== 1
              )
            );
            setTrainers(response.trainers);
            setLoading(false);
          })
          .catch((err) => {
            console.error("Error fetching available courses:", err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.error("Error fetching all courses:", err);
        setLoading(false);
      });
  }, [reload]);

  const currentItems = filteredCourses.slice(
    currentPage * perPage,
    (currentPage + 1) * perPage
  );

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected);
  };

  const openCourseAvailabilityModal = async (
    uuid: string,
    available: any,
    id: string | number
  ) => {
    setAssignCourse(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setAvailable(true);
    setIsAvailable(available); // if true the availability is edited else a new record created
    setCourseId(uuid);
    setId(id);
    setAdvertise(false);
    onOpen();
  };

  const openAssignCourseModal = async (id: string, trainers: Trainer[]) => {
    setAvailable(false);
    setAdvertise(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setAssignCourse(true);
    const ids: string[] = [];
    trainers.forEach((trainer) => ids.push(trainer.id.toString()));
    setTrainerIds(ids);
    setCourseId(id);
    onOpen();
  };

  const openAdvertiseCourseModal = async (id: string) => {
    setAvailable(false);
    setAssignCourse(false);
    setDeleteCourse(false);
    setIsBulkCourse(false);
    setCourseId(id);
    setAdvertise(true);
    onOpen();
  };

  const openDeleteCourseModal = async (id: string) => {
    setAvailable(false);
    setAssignCourse(false);
    setAdvertise(false);
    setIsBulkCourse(false);
    setCourseId(id);
    setDeleteCourse(true);
    onOpen();
  };

  const bulkCourseModal = async () => {
    setAvailable(false);
    setAssignCourse(false);
    setAdvertise(false);
    setDeleteCourse(false);
    setIsBulkCourse(true);
    onOpen();
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredCourses(courses);
    } else {
      if (courses) {
        const filtered = courses.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredCourses(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Flex
            minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}
          >
            <Box
              width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>

            <Box width={"100%"}>
              <AdminDashboardHeader />
              <Box
                pt="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
                <Flex
                  justifyContent="space-between"
                  alignItems="center"
                  py="26px"
                >
                  <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                    Courses
                  </Box>
                  <HStack>
                    {showLabels && (
                      <>
                        <Button
                          py="8px"
                          px="10px"
                          fontSize={14}
                          borderRadius={"2px"}
                          colorScheme="red"
                          height="32px"
                          onClick={() => {
                            navigate(Adminroutes.NewCourse);
                          }}
                        >
                          Add New Course
                        </Button>
                        <Button
                          py="8px"
                          px="10px"
                          fontSize={14}
                          borderRadius={"2px"}
                          colorScheme="red"
                          height="32px"
                          onClick={() => {
                            bulkCourseModal();
                          }}
                        >
                          Create Bulk Course
                        </Button>
                      </>
                    )}

                    <ExportExcel
                      title="Download Template"
                      excelData={ExcelDataExport}
                      fileName={"Bulk Course Template"}
                    />
                    {!showLabels && (
                      <Menu>
                        <MenuButton
                          as={IconButton}
                          aria-label="Options"
                          icon={<BsThreeDotsVertical />}
                          variant="outline"
                          bg="white"
                          height={"32px"}
                          borderRadius={"2px"}
                          _hover={{ bg: "gray.100" }}
                          _active={{ bg: "gray.200" }}
                        />
                        <MenuList>
                          <MenuItem
                            onClick={() => {
                              navigate(Adminroutes.NewCourse);
                            }}
                          >
                            Add New Course
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              bulkCourseModal();
                            }}
                          >
                            Create Bulk Course
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    )}
                  </HStack>
                </Flex>
                <Flex py="15px" justifyContent="">
                  <InputGroup
                    color="brand.subtitle"
                    bg="white"
                    width={["100%", "100%", "50%", "30%"]}
                    // mr="20px"
                  >
                    <Input
                      height="40px"
                      placeholder="Search for course"
                      onChange={(e) => handleSearchChange(e)}
                      fontSize={12}
                      size="sm"
                    />
                    <InputRightElement
                      pointerEvents="none"
                      children={<RiSearch2Line color="red" size="0.9rem" />}
                    />
                  </InputGroup>
                </Flex>
                <Box width="100%">
                  <TableContainer>
                    <Table variant="simple">
                      <Thead mb="10px">
                        <Tr
                          pb="10px"
                          borderBottom="1px solid"
                          borderColor="#D5D5D5"
                        >
                          <Th textTransform="none">
                            All Course(s) ({courses.length})
                          </Th>
                          <Th textTransform="none">Total Trainers</Th>
                          <Th textTransform="none">Course Code</Th>
                          <Th textTransform="none">Status</Th>

                          <Th textTransform="none">Options</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {currentItems.map((each, index) => (
                          <Tr key={index} bg="white">
                            <Td>
                              <HStack spacing="10px">
                                <Box height="55px" width="105px">
                                  <Image
                                    height="55px"
                                    width="105px"
                                    src={
                                      each.cover_image
                                        ? each.cover_image
                                        : engineering
                                    }
                                  />
                                </Box>
                                <Text
                                  fontWeight="600"
                                  fontSize="16px"
                                  color="#616161"
                                >
                                  {each.name.substring(0, 30)}...
                                </Text>
                              </HStack>
                            </Td>
                            <Td>{each.trainers.length}</Td>
                            <Td>{each.code}</Td>
                            <Td>
                              {each.is_available ? (
                                <HStack spacing={1}>
                                  <BsDot fontSize="24px" color="#00BA34" />
                                  <Text fontSize="14px">In Progress</Text>
                                </HStack>
                              ) : (
                                <HStack spacing={1}>
                                  <BsDot fontSize="24px" color="red" />
                                  <Text fontSize="14px">Not Available</Text>
                                </HStack>
                              )}
                            </Td>

                            <Td>
                              <HStack>
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  cursor={"pointer"}
                                  onClick={() => viewCourse(each.uuid)}
                                  height="30px"
                                >
                                  <RiEyeLine />
                                </Center>
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  onClick={() => {
                                    openCourseAvailabilityModal(
                                      each.uuid,
                                      each.is_available,
                                      each.id
                                    );
                                  }}
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                >
                                  <BsCalendarDay />
                                </Center>
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  onClick={() => {
                                    navigate(
                                      Adminroutes.EditCourseLink(each.uuid)
                                    );
                                  }}
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                >
                                  <HiOutlinePencil />
                                </Center>
                                {/* <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  onClick={() => {
                                    openDeleteCourseModal(each.uuid);
                                  }}
                                  cursor={"pointer"}
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                >
                                  <Image
                                    src={delete_vector}
                                    width="18px"
                                    height="18px"
                                  />
                                </Center> */}
                              </HStack>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                  {currentItems.length > 0 && !loading ? (
                    <Box pb={{ base: "0.5rem", sm: "1rem" }}>
                      <Pagination
                        breakLabel="..."
                        nextLabel={
                          showLabels ? (
                            <ArrowRightIcon style={{ fontSize: 18 }} />
                          ) : null
                        }
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={pageRangeDisplayed}
                        pageCount={Math.ceil(filteredCourses.length / perPage)}
                        previousLabel={
                          showLabels ? (
                            <ArrowLeftIcon style={{ fontSize: 18 }} />
                          ) : null
                        }                    
                        containerClassName="pagination"
                        pageLinkClassName="page-num"
                        previousLinkClassName="page-num"
                        nextLinkClassName="page-num"
                        activeLinkClassName="active"
                        // renderOnZeroPageCount={null}
                      />
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
            </Box>
          </Flex>
          {courseAvailable && (
            <Portal>
              {" "}
              <AvailableCourseModal
                isOpens={isOpen}
                onCloses={onClose}
                courseId={courseId}
                id={id}
                updateRecord={reloadData}
                isUpdate={isAvailable} // passing this prop to the modal to call the endpoint respectively
              />{" "}
            </Portal>
          )}
          {advertise && (
            <Portal>
              {" "}
              <AdvertiseCourseModal
                isOpenAdvert={isOpen}
                onCloseAdvert={onClose}
                courseId={courseId}
                advertise={advertise}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {deletecourse && (
            <Portal>
              {" "}
              <DeleteCourseModal
                isOpenDelete={isOpen}
                onCloseDelete={onClose}
                courseId={courseId}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}
          {assigncourse && (
            <Portal>
              {" "}
              <AssignCourseModal
                isOpened={isOpen}
                onClosed={onClose}
                selectedCourseId={courseId}
                trainerIds={trainerIds}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}

          {isBulkCourse && (
            <Portal>
              {" "}
              <BulkCourseModal
                isOpenBulk={isOpen}
                onClosed={onClose}
                isBulkCourse={isBulkCourse}
                reload={reloadData}
                isBatch={true}
              />{" "}
            </Portal>
          )}
        </Box>
      )}
    </>
  );
};

export default AdminCourses;
